import axios from 'axios'
import { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useNavigate, useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2
} from '../../Components/Main'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/pages/MenuDireito/unidades.css'
import ModalCriar from './MenuDireito-Modal/ModalCadDocumentoLocal'
import Modal from './MenuDireito-Modal/ModalEdiDocumento'

function Documentos() {
  let id = useParams<{ IdLocal: string }>()
  const history = useNavigate()
  sessionStorage.IdLocal = id['IdLocal']
  var user = authService.getCurrentUser()
  const [documentos, setDocumentos] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/documentocliente/list/' +
          user[0].IdEmpresa +
          '/' +
          sessionStorage.IdUnidade +
          '/' +
          id['IdLocal']
      )
      .then(response => {
        setDocumentos(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  function deleteDocumento(iddocumento: any) {
    if (window.confirm('Deletar documento?')) {
      axios
        .delete(
          process.env.REACT_APP_API_URL +
            '/api/v1/documentocliente/' +
            iddocumento
        )
        .then(response => {
          if (response.status === 200) {
            window.location.reload()
          } else {
            alert(response.data.message)
          }
        })
    }
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>
              {sessionStorage.uniRazaoSocial} / DADOS CADASTRAIS / DOCUMENTOS:
            </TitlePage1>
            <TitlePage2>Local:</TitlePage2>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalCriar />
          </div>
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>
        <div className="tabelaPadrao">
          <table>
            <tr>
              <th>UrlDocumento</th>
              <th>Validade</th>
              <th>Observação</th>
              <th>Status</th>
            </tr>
            {documentos
              .filter(val => {
                if (searchTerm === '') {
                  return val
                } else if (
                  val.dccUrl.toLowerCase().includes(searchTerm.toLowerCase())
                ) {
                  return val
                }
              })
              .map(documento => (
                <tbody key={documento.IdDocumentoCliente}>
                  <td>
                    <Link to={documento.dccUrl} target="_blank">
                      <button className="verifObserv2">
                        <i className="fas fa-file"></i>
                      </button>
                      {/* {documento.dccUrl}{' '} */}
                    </Link>
                  </td>
                  <td onClick={() => handleToggleComplete(documento)}>
                    {documento.dccValidade}
                  </td>
                  <td onClick={() => handleToggleComplete(documento)}>
                    <p className="Space2">{documento.dccObservacoes}</p>
                  </td>
                  <td>
                    <label
                      className="container"
                      onClick={() => handleToggleComplete(documento)}
                    >
                      <input
                        type="checkbox"
                        defaultChecked={!!documento.dccStatus}
                        disabled
                      />
                      <span className="checkmark"></span>
                    </label>
                    <button
                      onClick={() =>
                        deleteDocumento(documento.IdDocumentoCliente)
                      }
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </td>
                </tbody>
              ))}
          </table>
        </div>
      </ContainerPage>
    </div>
  )
}

export default Documentos
